import { CategoryArticlesApi } from '../api/categoryArticlesApi';
/**
 * Сервис для работы со статьями категории.
 * Инкапсулирует вызовы API и при необходимости может добавлять
 * кэширование, логику повтора и т.д.
 */
export class CategoryArticlesService {
    constructor() {
        this.api = new CategoryArticlesApi();
    }
    async getPage(categoryId, params = {}) {
        return this.api.getArticles(categoryId, params);
    }
}
